import React from 'react';
import { useParams } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import PlatformAuthForm from './oauth/PlatformAuthForm';
import { getPlatformConfig } from './oauth/platformConfig';

/**
 * Dynamic ad platform onboarding component
 * Handles /onboarding/:adPlatform routes dynamically
 *
 * NOTE: "adPlatform" refers to AD PLATFORM (amazon, walmart, google, tiktok, etc.)
 * This is different from SYSTEM PLATFORM (limitless, adjuggernaut, adrev)
 *
 * Extracts ad_platform from URL and renders appropriate content
 */
const DynamicPlatformOnboarding = () => {
  const { adPlatform } = useParams();
  const platformConfig = getPlatformConfig(adPlatform);

  // If platform not found in config, show error
  if (!platformConfig) {
    return (
      <Container className="dashboard">
        <Row>
          <Col md={12}>
            <h3 className="page-title">Platform Not Found</h3>
            <p>
              The platform &quot;{adPlatform}&quot; is not configured for onboarding.
            </p>
            <p>
              Please contact support if you believe this is an error.
            </p>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Authorize {platformConfig.displayName}</h3>
        </Col>
      </Row>
      <Row><br /></Row>
      <Row>
        <PlatformAuthForm
          adPlatform={adPlatform}
          apiType="ad-api"
          platformConfig={platformConfig}
        />
      </Row>
    </Container>
  );
};

export default DynamicPlatformOnboarding;
